import React from "react"
import {Button, Carousel} from 'antd'
import './styles.css';
import imgSlide1 from "../../assets/images/sample.png";
import imgSlideStatic from "../../assets/images/sampleStatic.png";
import {useMediaQuery} from "react-responsive";


const TopCarouselComponentTwo = ({type}) => {
    const isMobile = useMediaQuery({query: '(max-width: 560px)'})

    const mobileViewBody = null
        // <div className="carouselTopContainer">
        //     <div>Get Free</div>
        //     <text className='carouselMiddleText'>500MB</text>
        //     <Button style={{borderRadius: '5px'}}>Claim Reward</Button>
        // </div>
    const webViewBody = <div></div>

    var contents =
        [
            {image: imgSlide1, html: isMobile ? mobileViewBody : webViewBody},
            {image: imgSlide1, html: isMobile ? mobileViewBody : webViewBody},
            {image: imgSlide1, html: isMobile ? mobileViewBody : webViewBody}
        ]

    var contentsStatic =
        [
            {image: "https://d1a2kj008zo5cc.cloudfront.net/static_page_banner.jpg", html: isMobile ? mobileViewBody : webViewBody},
//            {image: imgSlideStatic, html: isMobile ? mobileViewBody : webViewBody},
//            {image: imgSlideStatic, html: isMobile ? mobileViewBody : webViewBody}
        ]

    const setCarouselItems = () => {
        var contentTypeList = type === 'STATIC' ? contentsStatic : contents;
        return (
            contentTypeList.map((content, index) => (
                <div key={index}>
                    {
                        content.html ?
                            <div className='banner-html'>
                                {content.html}
                            </div> : null
                    }
                    <img src={content.image} alt=""  height={isMobile ? "145px" : "500px"}/>
                </div>
            ))
        )

    }
    return (
        <>
            {
                isMobile ? <span className='carouselOverlay'/> : null
            }
            <Carousel autoplay={false}>
                {setCarouselItems()}
            </Carousel>
        </>

    )
}

export default TopCarouselComponentTwo
